export const USER_DETAILS = 'userDetails';
export const SET_LANGUAGE = 'currentLang';